"use client";

import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import React from "react";

/** @optimized using svgo:^3.0.2 */
export const MadeLocally = createSVGIcon(
  <>
    <path
      d="M24.25 12.48c0 4.56-2.943 8.755-6.033 11.883a39 39 0 0 1-5.725 4.747l-.119-.078a36.416 36.416 0 0 1-5.593-4.544C3.698 21.411.75 17.215.75 12.481.75 6.003 6.01.75 12.5.75s11.75 5.253 11.75 11.73Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <circle
      cx="12.5"
      cy="12.5"
      r="5.75"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </>,
  "MadeLocally",
  { viewBox: "0 0 25 30", titleAccess: "MadeLocally", fill: "none" }
);
